import CircularProgress from '@mui/material/CircularProgress'
import Stack from '@mui/material/Stack'
import React, { useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import { useNavigate } from 'react-router-dom'
import { PaymentSteps } from '../../app/paymentSteps'
import usePaymentStep from '../../hooks/usePaymentStep'

type PaymentRedirectReceiverProps = {
  type: 'success' | 'cancel'
}

const PaymentRedirectReceiver: React.FC<PaymentRedirectReceiverProps> = ({
  type,
}) => {
  const [_currentPaymentStep, setCurrentPaymentStep] = usePaymentStep()
  const navigate = useNavigate()

  useEffect(() => {
    setCurrentPaymentStep(
      type === 'success' ? PaymentSteps.FINISH : PaymentSteps.FINISH_ERROR,
    )
    navigate('/')
  }, [])

  return (
    <Stack alignItems="center" justifyContent="center">
      <h1>
        <FormattedMessage id="page.webPayment.paymentRedirectReceiver.heading" />
      </h1>
      <CircularProgress />
    </Stack>
  )
}

export default PaymentRedirectReceiver
